export default __webpack_public_path__ + "2241f7a6ea1951c88705820701a93605.otf";